import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as StampAPI from "@/api/stamp";
import { isSuccess } from "@/api/response";
import { RegisterRequest } from "@/api/stamp/request";
import { RegisterResponse } from "@/api/stamp/response";

const MODULE_NAME = "stamp/regist";

/**
 * スタンプカード設定情報取得APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  registerResponse: RegisterResponse = {} as RegisterResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.registerResponse);
  }

  get getMessage() {
    return this.registerResponse.message;
  }

  get getPreviewUrl() {
    if (this.registerResponse.results) {
      return this.registerResponse.results.previewUrl;
    } else {
      return "";
    }
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const registerResponse = await StampAPI.register(registerRequest);
    return {
      registerResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      registerResponse: {} as RegisterResponse
    };
  }
}

export default getModule(Modify);
